import type { User } from '@/types/user';

/**
 * Demo-mode fabricated response for updating a user.
 * Used as the demoFn for useUpdateUser.
 */
export function updateUserDemoResponse({ data }: { userId: string; data: Partial<User> }): User {
  return {
    ...data,
    updatedAt: new Date().toISOString(),
  } as User;
}
